import { useWindowDimensions } from 'react-native'

/**
 * Layout breakpoints (Q1). One codebase serves phone, tablet and web, so screen
 * widths are bucketed rather than platform-checked — a narrow browser window
 * behaves like a phone, a wide one like the web portal.
 */
export const BREAKPOINTS = {
  tablet: 768, // ≥ this: tablet layout
  wide: 1024, // ≥ this: desktop / web portal
} as const

export interface Responsive {
  width: number
  height: number
  isPhone: boolean // < 768
  isTablet: boolean // 768–1023
  isWide: boolean // ≥ 1024
}

/** Reactive breakpoint info; recomputes on rotation / window resize. */
export function useResponsive(): Responsive {
  const { width, height } = useWindowDimensions()
  return {
    width,
    height,
    isPhone: width < BREAKPOINTS.tablet,
    isTablet: width >= BREAKPOINTS.tablet && width < BREAKPOINTS.wide,
    isWide: width >= BREAKPOINTS.wide,
  }
}
